import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgOption } from '@ng-select/ng-select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@Component({
  selector: 'emi-filter-control',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule,
    MatFormFieldModule, MatInputModule, MatIconModule, TranslateModule,
    MatDatepickerModule, MatSelectModule, MatAutocompleteModule,
    MatChipsModule],
  templateUrl: './filter-control.component.html',
  styleUrls: ['./filter-control.component.css']
})

export class FilterControlComponent implements OnInit {
  @Output() filters = new EventEmitter<any>();
  public form: FormGroup;
  public statusCatalog: NgOption[] = [
    { value: 'approved', label: 'Aprobado' },
    { value: 'rejected', label: 'Rechazado' },
    { value: 'pending', label: 'Pendiente' }
  ];
  public viewAdvancedSection: boolean = false;


  constructor(private readonly fb: FormBuilder) {
  }


  ngOnInit() {
    this.createForm();
  }



  public createForm() {
    const coordinatePattern = /^-?\d+\.\d+,\s*-?\d+\.\d+$/;

    this.form = this.fb.group({
      status: ['', []],
      dateStart: ['', []],
      dateEnd: ['', []],
      idPlattform: ['', []],
      location: ['', [Validators.pattern(coordinatePattern)]],
      fullName: ['', []]
    });
  }

  public setFilters() {
    this.filters.emit({
      event: 'filter',
      data: this.form.value
    });
  }

  public reportFilters() {
    this.filters.emit({
      event: 'report',
      data: this.form.value
    });
  }

  public viewOtherFilters() {
    console.log("viewOtherFilters");
    this.filters.emit({
      event: 'advancedFilter'
    });
  }

  public clearFilters() {
    this.form.reset();
    this.filters.emit({
      event: 'reset',
      data: null
    });
  }

}
